import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8340' : 'https://api.databin.me',
    document: {},
  },
  mutations: {

  },
  actions: {
    readDocument(store, { hash, version }) {

    },
  },
  getters: {

  },
});
